import React, {useState, useEffect} from "react";
import {Form, Input, Button, Card, Modal, Select, notification} from 'antd';
import {Link} from "react-router-dom";
import jsonfile from './expenseclaim.json';
import {CisUI} from '../../../../util/CISUI';
import 'react-smart-data-table/dist/react-smart-data-table.css'
import Config from "../../../../util/config";
import axios from "../../../../util/Api";
import {useHistory} from "react-router-dom";

var Barcode = require('react-barcode');
const {Option} = Select;

const ReachableContext = React.createContext();
const UnreachableContext = React.createContext();


const HRExpenseDetails = (props) => {

    const formRef = React.createRef();

    const [modal, contextHolder] = Modal.useModal();
    const [loading, setLoading] = useState([]);

    const [state, setState] = useState({
        po: {},
        items: [],
        isPOApprover: 0,
        hasBill: 0
    })


    const userID = props.match.params.id;
    let userData = [];
    // console.log("Userid : "+props.match.params.id);
    let isEdit = 0;
    if (userID > 0) {
        isEdit = 1;
    }

    const print = () => {
        return <Link to={"print/" + userID}>Print</Link>
    };

    const onFinish = () => {

    }

    let Title = jsonfile.details_title;
    let endpoint = jsonfile.urls.add;
    let redirectto = "../" + jsonfile.urls.list;

    if (isEdit === 1) {

        Title = jsonfile.details_title;
        endpoint = jsonfile.urls.edit + "/" + userID;
        redirectto = "../../" + jsonfile.urls.list;
    }

    useEffect(() => {
        getPODetails();
    }, []);

    const getPODetails = () => {
        document.getElementById("loader").style.display = "block";
        axios.get(Config.apiserver +jsonfile.urls.view+"/"+userID)
            .then((res) => {
                // console.log(res.data);
                if (res.data.status === 1) {
                    setState({
                        po: res.data.podata,
                        items: res.data.items,
                        isPOApprover: res.data.isPOApprover,
                        hasBill: res.data.hasBill
                    });
                    document.getElementById("loadstatus").style.display = "none";
                }
                else {
                    document.getElementById("loadstatus").style.display = "block";
                    document.getElementById("loadstatus").innerText = "No data found";
                }
                document.getElementById("loader").style.display = "none";
            })
            .catch((error) => {
                document.getElementById("loader").style.display = "block";
                document.getElementById("loadstatus").innerText = "No data found";
                console.log(error);
            });
    }

    const [form] = Form.useForm();
    const history = useHistory();

    const [isModalVisible, setIsModalVisible] = useState(false);
    const [isConfirmModalVisible, setIsConfirmModalVisible] = useState(false);
    const [isRejectModalVisible, setIsRejectModalVisible] = useState(false);

    const showModal = () => {
        setIsModalVisible(true);
    };

    const handleOk = () => {
        setIsModalVisible(false);
    };

    const handleCancel = () => {
        setIsModalVisible(false);
    };

    const showModalCofirm = () => {
        setIsConfirmModalVisible(true);
    };

    const handleOkConfirm = () => {
        setIsConfirmModalVisible(false);
        PoStatusUpdate(state.po.id,1);
    };

    const handleCancelConfirm = () => {
        setIsConfirmModalVisible(false);
    };

    const showModalReject = () => {
        setIsRejectModalVisible(true);
    };

    const handleOkReject = () => {
        setIsRejectModalVisible(false);
        PoStatusUpdate(state.po.id,3);
    };

    const handleCancelReject = () => {
        setIsRejectModalVisible(false);
    };

    const handleChange = () => {

    }



    const PoStatusUpdate = (id,status) => {
        document.getElementById("loader").style.display = "block";
        axios.get("vendor/voucherstatuschange?vo_id="+id+"&status="+status)
            .then((res) => {
                document.getElementById("loader").style.display = "none";
                console.log(res.data);
                if(res.data.status === 1) {
                    notification.success({
                        message: 'Success',
                        type: "success",
                        description: res.data.msg
                    });
                    getPODetails();
                }
                else {
                    document.getElementById("loader").style.display = "none";
                    notification.success({
                        message: 'Failed',
                        type: "danger",
                        description: res.data.msg
                    });
                }
            })
            .catch((error) => {
                console.log(error);
                document.getElementById("loader").style.display = "none";
            });
    }

    var totalAmount = 0;

    const config = {
        title: 'Alert',
        content: (
            <>
                <ReachableContext.Consumer>{name => `Reachable: ${name}!`}</ReachableContext.Consumer>
                <br />
                <UnreachableContext.Consumer>{name => `Unreachable: ${name}!`}</UnreachableContext.Consumer>
            </>
        ),
    };

    const Print = () => {
        window.print();
    }

    return (
        <>
            <Card title={Title}>
                {CisUI().showLoading}
                {
                    isEdit === 1
                        ? CisUI().addAction('../../' + jsonfile.urls.list)
                        : CisUI().addAction('../' + jsonfile.urls.list)
                }

                <h3 id="loadstatus"></h3>

                {
                    state.po.id > 0 ?
                        <>
                            <div className="row">
                                <div className="col-md-12" style={{textAlign: 'center'}}>
                                    <div style={{
                                        width: '100%',
                                        background: 'white',
                                        border: '1px #ddd solid',
                                        padding: '20px'
                                    }}>
                                        <table style={{width: '100%'}}>
                                            <tr>
                                                <td style={{width: '50%', textAlign: 'left'}}>
                                                    <img alt="cop" style={{width: '120px'}} src={Config.print_logourl}/>
                                                    {/*<div>{Config.address}</div>*/}
                                                    {/*<div>{Config.city},{Config.state},{Config.zipcode}</div>*/}
                                                    {/*<div>Phone : {Config.phone}</div>*/}
                                                    {/*<div>Email : {Config.email}</div>*/}
                                                    {/*<div>Website : {Config.website}</div>*/}
                                                </td>
                                                <td style={{width: '50%', textAlign: 'right'}}>
                                                    <h2>EXPENSE</h2>
                                                    <div>Date : {CisUI().DateFormat(state.po.date)}</div>
                                                    <div>Invoice Number : {state.po.invoice_number}</div>
                                                    <div><Barcode height={50} value={state.po.invoice_number}/></div>
                                                </td>
                                            </tr>
                                        </table>
                                        <table id="itemtable" style={{marginTop: '30px'}}
                                               className="ptable table table-bordered">
                                            <thead>
                                            <tr>
                                                <th>Employee</th>
                                                <th>Date</th>
                                                <th>Status</th>
                                            </tr>
                                            </thead>
                                            <tbody>
                                            <tr>
                                                <th>{state.po.employee}</th>
                                                <th>{CisUI().DateFormat(state.po.required_by_date)}</th>
                                                <th>{CisUI().getBillSatus(state.po.status)}</th>
                                            </tr>
                                            </tbody>
                                        </table>

                                        <table id="itemtable" style={{marginTop: '30px'}}
                                               className="ptable table table-bordered">
                                            <thead>
                                            <tr>
                                                <th>#</th>
                                                <th style={{textAlign: 'left'}}>Item</th>
                                                <th style={{textAlign: 'right'}}>Amount</th>
                                                <th style={{textAlign: 'left'}}>Note</th>
                                                <th className="no-print">Attachment</th>
                                            </tr>
                                            </thead>
                                            <tbody>
                                            {state.items.map((item, idx) => (
                                                <tr id="addr0" key={idx}>
                                                    <td style={{width: '30px'}}>{(idx + 1)}</td>
                                                    <td style={{textAlign: 'left'}}>{item.item_name}</td>
                                                    <td style={{
                                                        width: '70px',
                                                        textAlign: 'right'
                                                    }}>{CisUI().getCurrencyFormated1(item.amount)}</td>
                                                    <td style={{textAlign: 'left'}}>{item.remark}</td>
                                                    <td className="no-print" style={{width: '150px'}}>{
                                                        item.files.map((file, fl)=> {
                                                            return <a href={Config.fileserver+""+file.location} target="_blank" className="btn btn-primary btn-sm btn-circle">
                                                                <i className="fa fa-file"></i>
                                                            </a>
                                                        })
                                                    }</td>
                                                </tr>
                                            ))}
                                            </tbody>
                                            <tfoot>
                                            <tr>
                                                <td colSpan={2} style={{textAlign: 'right', fontWeight: 'bold'}}>Total</td>
                                                <td style={{
                                                    textAlign: 'right',
                                                    fontWeight: 'bold'
                                                }}>{CisUI().getCurrencyFormated1(state.po.total)}</td>
                                                <td></td>
                                                <td></td>
                                            </tr>
                                            </tfoot>
                                        </table>

                                    </div>
                                </div>
                            </div>

                            <div className="row no-print">
                                <div className="col-md-12" style={{textAlign: 'center', marginTop: '30px'}}>
                                    {
                                        state.po.status === 0 ?
                                            state.isPOApprover === 1 ?
                                                <>
                                                    <Button id="submitbutton" type="danger" onClick={showModalReject}
                                                            htmlType="submit">Reject</Button>
                                                    <Button id="submitbutton" type="primary" onClick={showModalCofirm}
                                                            htmlType="submit">Approve</Button>
                                                </>
                                                : ""
                                            : ""
                                    }

                                    <Button id="submitbutton" type="primary" onClick={Print}
                                            htmlType="button">Print</Button>
                                    <Button type="info" onClick={() => history.goBack()} htmlType="back">Back</Button>
                                </div>
                            </div>
                        </>
                        :
                        <></>
                }


            </Card>
            <Modal title="Send To Anyone" visible={isModalVisible} okText={"Send"} onOk={handleOk} onCancel={handleCancel}>
                <Form
                    form={form}
                    {...CisUI().formItemLayout}
                    name="input"
                    ref={formRef}
                    className="ant-advanced-search-form"
                    onFinish={onFinish}>

                    <div className="row">
                        <div className="col-md-12">
                            <Form.Item
                                label="Email Address"
                                name="email"
                                onChange={handleChange}
                                rules={[
                                    {
                                        required: true,
                                        message: "Enter email addres, separate by comma for multiple email "
                                    },
                                ]}
                            >
                                <Input placeholder="Enter email address" />
                            </Form.Item>
                        </div>
                    </div>

                </Form>
            </Modal>

            <Modal title="Alert" visible={isConfirmModalVisible} okText={"Confirm"} onOk={handleOkConfirm} onCancel={handleCancelConfirm}>
                <h4>Are you sure you want to approve ?</h4>
            </Modal>

            <Modal title="Alert" visible={isRejectModalVisible} okText={"Confirm"} onOk={handleOkReject} onCancel={handleCancelReject}>
                <h4>Are you sure you want to reject ?</h4>
            </Modal>

        </>
    );
};

export default HRExpenseDetails;